import clientStrapi from "src/config/strapi";
import clientAxios from "./../../../config/axios";
import { RegisterTestRequest } from "./models/RegisterTestRequest";

export const register = async (data: any) => {
  const url = `/users/${data.user_id}`;
  return clientStrapi().put(url, { test_results: data });
};

export const updateSelfKnowledge = (data: any) => {
  const url = `/users/${data.user_id}`;
  console.log("calling update self");
  return clientStrapi().put(url, { test_results: data });
};

export const updateWelfare = (data: any) => {
  return clientStrapi().post(`/wellness-tests`, { data });
};

export const updateDepression = (_data: any) => {
  // Backend AWS deprecado. El nivel de depresion se calcula en el front
  // y las respuestas/pesos ya quedan persistidos en user.test_results via
  // el thunk `register` previo (PUT /users/:id a Strapi). No-op para que
  // el step avance a la pantalla de resultados sin tocar el backend.
  return Promise.resolve({ data: {} } as any);
};
